import SystemDefaultsComponent from 'app/SettingsManagement/SystemDefaultsManagement/SystemDefaultsComponent'

const SystemDefaultsPage = () => {
  return <SystemDefaultsComponent />
}

export default SystemDefaultsPage
